// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {removePost} from 'mattermost-redux/actions/posts';

import FailedPostOptions from './failed_post_options.jsx';

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            removePost
        }, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(FailedPostOptions);



// WEBPACK FOOTER //
// ./components/post_view/failed_post_options/index.js